import { arrayOf } from "utils/helpers/array-of";
import { canUseDOM } from "utils/helpers/can-use-dom";
import { getRandomInteger } from "utils/math/get-random-integer";

export const uniqId = (separator = "-") => {
  let array;

  if (canUseDOM) {
    array = new Uint32Array(8);
    crypto.getRandomValues(array);
  } else {
    array = arrayOf(8, () => getRandomInteger(2 ** 32));
  }

  let str = "";

  for (let i = 0; i < array.length; i++) {
    str += (i < 2 || i > 5 ? "" : separator) + array[i].toString(16).slice(-4);
  }

  return str;
};
